import { render } from "./AddAccountDialog.vue?vue&type=template&id=398d8905&scoped=true"
import script from "./AddAccountDialog.vue?vue&type=script&lang=js"
export * from "./AddAccountDialog.vue?vue&type=script&lang=js"

import "./AddAccountDialog.vue?vue&type=style&index=0&id=398d8905&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-398d8905"]])

export default __exports__